module.exports = __webpack_public_path__ + "static/media/img_all.b23f490d.png";